import axios from "axios";
import router from "@/router/routes";

const afiliadoAxios = axios.create({
  baseURL: process.env.VUE_APP_URL_API,
});

afiliadoAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("afiliado_token");
  if (token) {
    config.headers["x-afiliado-token"] = token;
  }
  return config;
});

export const afiliadoApi = {
  get(endpoint) {
    return afiliadoAxios.get(endpoint);
  },
  post(endpoint, body) {
    return afiliadoAxios.post(endpoint, body);
  },
  put(endpoint, body) {
    return afiliadoAxios.put(endpoint, body);
  },
  delete(endpoint) {
    return afiliadoAxios.delete(endpoint);
  },
};

const token = localStorage.getItem("afiliado_token");
const afiliado = JSON.parse(localStorage.getItem("afiliado") || "null");

const state = token
  ? { status: { loggedIn: true }, token, afiliado }
  : { status: {}, token: null, afiliado: null };

const actions = {
  login({ commit }, { email, password }) {
    return afiliadoAxios
      .post("afiliados/login", { email, password })
      .then((response) => {
        if (response.data.status === "success") {
          localStorage.setItem("afiliado_token", response.data.token);
          localStorage.setItem("afiliado", JSON.stringify(response.data.afiliado));
          commit("loginSuccess", response.data);
          router.push("/afiliado");
        } else {
          commit("loginFailure");
          return Promise.reject(response.data.message || "Credenciais inválidas.");
        }
      });
  },

  logout({ commit }) {
    localStorage.removeItem("afiliado_token");
    localStorage.removeItem("afiliado");
    commit("logout");
  },

  refresh({ commit }) {
    return afiliadoAxios.get("afiliados/user").then((response) => {
      if (response.data.status === "success") {
        localStorage.setItem("afiliado", JSON.stringify(response.data.afiliado));
        commit("refresh", response.data.afiliado);
      }
    });
  },
};

const mutations = {
  loginSuccess(state, data) {
    state.status = { loggedIn: true };
    state.token = data.token;
    state.afiliado = data.afiliado;
  },
  loginFailure(state) {
    state.status = {};
    state.token = null;
    state.afiliado = null;
  },
  logout(state) {
    state.status = {};
    state.token = null;
    state.afiliado = null;
  },
  refresh(state, afiliado) {
    state.afiliado = afiliado;
  },
};

export const afiliadoAuth = {
  namespaced: true,
  state,
  actions,
  mutations,
};
